import React from 'react';
import PropTypes from 'prop-types';

import Button from '$partials/ui/button';
import { CarouselProvider } from '$contexts/carousel';
import Carousel, { CarouselNavigation, CarouselSlide } from '$partials/ui/carousel';
import Image from '$partials/media/image';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleCarouselMap = ({
    title,
    subtitle,
    images = {}
}) => {
    return (
        <>
            {images.items.length > 1 ? (
                <div className='my-44 md:my-70 bg-white mx-10 sm:mx-0 md:-mx-20 pt-30 pb-50'>
                    {title && (
                        <div className='px-30 sm:px-20 md:px-40'>
                            <p className='type-style-3'>{title}</p>
                        </div>
                    )}
                    {subtitle && (
                        <div className='mt-10 sm:mt-5 px-30 sm:px-20 md:px-40'>
                            <p className='type-style-8'>{subtitle}</p>
                        </div>
                    )}
                    <CarouselProvider>
                        <div className='swiper-navigation z-10 hidden md:mt-40 md:flex relative'>
                            <CarouselNavigation/>
                        </div>
                        <Carousel className='mt-30 sm:mt-40 flex swiper-wrapper h-auto w-full md:mt-[-45px] overflow-hidden embed-carousel'>
                            {images.items?.map((item, idx) => {
                                return (
                                    <CarouselSlide
                                        className='h-auto flex flex-wrap w-9/12 sm:w-5/12 px-10 sm:px-20'
                                        index={idx}
                                        key={`carousel-item-${idx}`}>
                                        <a
                                            className='w-full'
                                            href={item.ctaLink}
                                            rel='noreferrer noopener nofollow'
                                            target='_blank'>
                                            <Image
                                                loadWidth={1046}
                                                {...item.map} />
                                        </a>
                                        {item.ctaLink && item.ctaLabel && (
                                            <Button
                                                as='a'
                                                className='mt-20 flex items-center bg-orange text-white rounded  type-style-7 px-20 py-15'
                                                href={item.ctaLink}
                                                type='button'>
                                                {item.ctaLabel}
                                            </Button>
                                        )}
                                    </CarouselSlide>
                                );
                            })}
                        </Carousel>
                    </CarouselProvider>
                </div>
            ) : (
                <div className='w-full flex flex-wrap my-30 md:my-60 sm:flex-row-reverse'>
                    <div className='w-full sm:w-8/12 md:w-7/12 px-10 sm:px-20 sm:mr-w-2/12 md:mr-w-1/12'>
                        {title && (
                            <div>
                                <p className='type-style-3'>{title}</p>
                            </div>
                        )}
                        {subtitle && (
                            <div className='mt-10 sm:mt-5'>
                                <p className='type-style-8'>{subtitle}</p>
                            </div>
                        )}
                        <div
                            className='mt-30 sm:mt-40 h-auto flex flex-wrap w-full'>
                            <Image
                                loadWidth={1046}
                                {...images.items?.[0]?.map} />
                            {images.items?.[0]?.ctaLink && images.items?.[0]?.ctaLabel && (
                                <Button
                                    as='a'
                                    className='mt-20 flex items-center bg-orange text-white rounded  type-style-7 px-20 py-15'
                                    href={images.items?.[0]?.ctaLink}
                                    type='button'>
                                    {images.items?.[0]?.ctaLabel}
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleCarouselMap.propTypes = {
    images: PropTypes.shape({
        items: PropTypes.array,
    }),
    subtitle: PropTypes.string,
    title: PropTypes.string,
};

export default ModuleCarouselMap;
